/*!
 * Copyright (c) 2018-present Cyclope.ai
 * LICENSE file is in the root directory of this source tree.
 * */

import * as Utils from '@Cyclope-Utils/index';
import {UserAuthorizationLoadActionFail, UserAuthorizationLoadActionInProgress, UserAuthorizationLoadActionSuccess} from '@tunnel-store/index';
import {Dispatch} from 'redux';

/**
 * @function UserAuthorizationLoadActionCreator
 * @param { any } user
 * @return {Promise<any>}  Promise
 */
export function UserAuthorizationLoadActionCreator(): (
    dispatch: Dispatch<any>, {}) => Promise<any> {
  return async (dispatch: Dispatch<any>) => {
    dispatch(UserAuthorizationLoadActionInProgress());  // authorisations

        await Utils.authorisations()
        .then((response: any)=> {
      if (response.ok) {
        /**
         * @constant
         * @name contentHeader
         * @type string
         */
        const contentHeader: string = response.headers.get('content-type');
        { /* Comparer les valeurs */
        }
        if (contentHeader && contentHeader !== null &&
            contentHeader.indexOf('application/json') !== -1) {
          if (response.status === 200) {
            { /** Renvoie une promise qui retourne le résultat en JSON  */
            }
            response.json().then((data: any) => {
              localStorage.setItem('authorization', data);
              dispatch(UserAuthorizationLoadActionSuccess(data))
            });  // État du state : resultat final
          } else if (response.status === 203) {
            { /** Renvoie une promise qui retourne le résultat undefined */
            }
            response.json().then(
                (text: any) => dispatch(UserAuthorizationLoadActionSuccess(
                    [])))  // État du state : resultat final
          }
        }
        if (contentHeader === null || contentHeader === undefined) {
          if (response.status === 203) {
            { /** Renvoie une promise qui retourne le résultat undefined */
            }
            response.text().then(
                (text: any) => dispatch(UserAuthorizationLoadActionSuccess(
                    [])))  // État du state : resultat final
          }
        }
      } else {
        throw ({
          message: response.statusText,
          status: response.status,
          url: response.url,
          headers: response.headers
        });
      }}).catch( (error: any) => {
                dispatch(UserAuthorizationLoadActionFail(error.status + ' -- ' + Math.random())) /* { // État du state : échec  }*/
                Utils.fetchLogs(error.url,error.message,error.status,error.headers)
            })
  }
}


// WEBPACK FOOTER //
// ./src/apps/tunnel/store/actionsCreator/actions/authorization/index.ts